import React from 'react';
import {t} from '@lingui/core/macro';

import Filters from 'shared/ui/icons/General/Filters';

import IconButton, {IIconButtonProps} from './IconButton';

type IFilterButtonProps = Omit<IIconButtonProps, 'icon' | 'title'>;

const FilterButton: React.FC<IFilterButtonProps> = ({...props}) => {

    return (
        <IconButton
            icon={<Filters />}
            title={t`Фильтры`}
            {...props}
        />
    );
};

export default FilterButton;